"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionsButtons = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _ListItemButton = require("./ListItemButton");
var _MainButtons = require("./MainButtons");
var _ReviewsButton = require("./ReviewsButton");
var _VisualizeButton = require("./VisualizeButton");
var _DeleteButton = require("./DeleteButton");
var _hooks = require("../hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ActionsButtons = function ActionsButtons(props) {
  var product = props.product;
  var _useToggle = (0, _hooks.useToggle)(),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    isCollapsed = _useToggle2[0],
    toggleCollapse = _useToggle2[1];
  var MainButtons = props.mainButtonsComponent || _MainButtons.MainButtons;
  var ReviewsButton = props.reviewsButtonComponent || _ReviewsButton.ReviewsButton;
  var VisualizeButton = props.visualizeButtonComponent || _VisualizeButton.VisualizeButton;
  var DeleteButton = props.deleteButtonComponent || _DeleteButton.DeleteButton;
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    padding: 1.5
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1,
    alignItems: "center",
    wrap: "nowrap"
  }, /*#__PURE__*/_react.default.createElement(MainButtons, props), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: toggleCollapse
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, isCollapsed ? "keyboard_arrow_up" : "keyboard_arrow_down")))), /*#__PURE__*/_react.default.createElement(_core.Collapse, {
    in: isCollapsed
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    marginTop: 1
  }, /*#__PURE__*/_react.default.createElement(_core.List, {
    component: "nav"
  }, props.renderExtraActionsButtons && props.renderExtraActionsButtons(product), /*#__PURE__*/_react.default.createElement(ReviewsButton, props, function (_ref) {
    var onClick = _ref.onClick;
    return /*#__PURE__*/_react.default.createElement(_ListItemButton.ListItemButton, {
      onClick: onClick,
      icon: "star_rate",
      label: /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
        id: "Reviews"
      })
    });
  }), /*#__PURE__*/_react.default.createElement(VisualizeButton, props, /*#__PURE__*/_react.default.createElement(_ListItemButton.ListItemButton, {
    icon: "remove_red_eye",
    label: /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "Visualize"
    })
  })), /*#__PURE__*/_react.default.createElement(DeleteButton, props, function (_ref2) {
    var onClick = _ref2.onClick;
    return /*#__PURE__*/_react.default.createElement(_ListItemButton.ListItemButton, {
      onClick: onClick,
      icon: "delete",
      label: /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
        id: "Delete"
      })
    });
  })))));
};
exports.ActionsButtons = ActionsButtons;